import React, { useEffect, useState, useContext, useRef } from 'react';
import { NavLink, Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify"
import { AuthContext } from "../context/authContext";
import { useEstadoApp } from "../context/EstadoAppContext";
import { useSession } from '../hooks/useSession'; // Importar useSession
import { useChatSoporte } from '../context/ChatSoporteContext';

import ButtonNavLink from './ui/ButtonNavLink';
import FormularioNuevaONG from './FormularioNuevaONG'; // Importar el formulario
//import FormularioNuevoReferente from './FormularioNuevoReferente'; // Importar el formulario de referente
import { Modal } from './ui/Modal'; // Importar el componente Modal reutilizable

import ImageNav from '../marca_botonera-01.png';
import { NotificacionesUsuarioIndicador } from './NotificacionesUsuarioIndicador';
import { FormularioCrearNotificacion } from './FormularioCrearNotificacion';

// Clase base de los items del menu Admin (todos los NavLink del dropdown comparten estilo).
const adminItemClass = ({ isActive }) =>
	`block px-4 py-2 text-sm transition-colors ${isActive
		? 'bg-blue-50 text-blue-600 dark:bg-gray-800 dark:text-blue-400'
		: 'text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800'}`;

// Encabezado de seccion dentro del menu Admin (separa por tipo de herramienta).
const AdminMenuSection = ({ title }) => (
	<div className="px-4 pt-3 pb-1 text-[11px] font-semibold uppercase tracking-wide text-gray-400 dark:text-gray-500">
		{title}
	</div>
);

const Navbar = () => {
	const auth = useContext(AuthContext) //**agregado */
	const { user, role, roles } = useContext(AuthContext);
	const { logout } = useSession(); // Extraer logout de useSession
	const { estadoAppX } = useEstadoApp();
	// Chat de soporte: el item del menú Admin abre el mismo panel que el botón
	// flotante y muestra la cola de mensajes pendientes.
	// `disponible` es false si el navbar se renderiza fuera del provider (la
	// pantalla pública con la sesión todavía viva): ahí el item no se muestra,
	// porque el botón no tenía dónde abrir.
	const chatSoporte = useChatSoporte();
	const { cola: colaChat, abrirPanel: abrirChatSoporte } = chatSoporte;

	const [isModalOpen, setIsModalOpen] = useState(false); // Estado para el modal
	const [modalType, setModalType] = useState(null); // Estado para el tipo de modal
	const [isNotifModalOpen, setIsNotifModalOpen] = useState(false); // Estado para el modal de notificaciones (admin)
	const [adminMenuOpen, setAdminMenuOpen] = useState(false); // Estado para el menú desplegable de admin
	const adminMenuRef = useRef(null); // Referencia para cerrar el menú admin al hacer clic afuera
	//const [refreshKey, setRefreshKey] = useState(0); // Estado para refrescar datos    

	useEffect(() => {
		if (user) {
			toast(`Bienvenido: ${user}`);
		}
	}, [])

	// Cierra el menú admin al hacer clic afuera
	useEffect(() => {
		if (!adminMenuOpen) return;
		const handleClick = (e) => {
			if (adminMenuRef.current && !adminMenuRef.current.contains(e.target)) {
				setAdminMenuOpen(false);
			}
		};
		document.addEventListener('mousedown', handleClick);
		return () => document.removeEventListener('mousedown', handleClick);
	}, [adminMenuOpen]);

	// Clases base para los enlaces
	const linkClasses = ({ isActive }) =>
		`px-4 py-2 rounded-md transition-colors duration-200 text-sm font-medium ${isActive
			? 'bg-blue-500 text-white dark:bg-blue-700'
			: 'text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700'
		}`;

	const closeModal = () => {
		setIsModalOpen(false);
		setModalType(null);
	};

	return (
		<>
			<nav className="flex items-center justify-between px-4 py-2">
				<div className="flex items-center space-x-4">
					<div>
						{/* Logo */}
					<img
						src={ImageNav}
						alt="Logo empresa"
						className=""
					/>
					</div>

					{/* Enlaces de navegación generales */}
					<div className="flex items-center space-x-2">
						<NavLink to="/inicio" className={linkClasses}>
							Inicio
						</NavLink>
						<NavLink to="/informes" className={linkClasses}>
							Informes
						</NavLink>
						<NavLink to="/tableros" className={linkClasses}>
							Tableros
						</NavLink>
						<NavLink to="/mapas" className={linkClasses}>
							Mapas
						</NavLink>
						<NavLink to="/calendario" className={linkClasses}>
							Calendario
						</NavLink>
						<NavLink to="/contactos-ong" className={linkClasses}>
							Contactos de proyecto
						</NavLink>
						{(role === "admin_mejoramientos" || role === "mejoramientos"
							|| (Array.isArray(roles) && roles.some((r) => r === "admin_mejoramientos" || r === "mejoramientos"))) && (
							<NavLink to="/alertas-mejoramientos" className={linkClasses}>
								Alertas de Mejoramientos
							</NavLink>
						)}
						{(role === "seguimiento_obras"
							|| (Array.isArray(roles) && roles.includes("seguimiento_obras"))) && (
							<NavLink to="/alertas-obras" className={linkClasses}>
								Alertas de Obras
							</NavLink>
						)}
					</div>
				</div>

				<div className="flex items-center space-x-2">
					{/* Nueva ONG */}
					{estadoAppX === "inicial" && (
						<ButtonNavLink to="/nuevaONG">Nueva ONG</ButtonNavLink>
					)}
					{(estadoAppX === "nuevo" || estadoAppX === "ediT") && (
						<button
							onClick={() => {
								setIsModalOpen(true);
								setModalType('ong');
							}}
							className="px-4 py-2 text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700 rounded-md hover:bg-green-600 transition-colors duration-200 text-sm font-medium"
						>
							Nueva ONG
						</button>
					)}

					{(role === "registro_ongs"
						|| (Array.isArray(roles) && roles.includes("registro_ongs"))) && (
						<NavLink to="/informe-organizaciones" className={linkClasses}>
							Informe de Organizaciones
						</NavLink>
					)}

					{/* Admin: Tramitaciones se mantiene como link directo.
					    El link directo a "Tableros V2" se fue: ahora /tableros es el
					    tablero nuevo y está en el menu general, para todos los roles. */}
					{role === "admin" && (
						<>
							<NavLink to="/tramitaciones" className={linkClasses}>
								Tramitaciones
							</NavLink>
						</>
					)}

					{/* Admin: menú desplegable agrupado */}
					{role === "admin" && (
						<div className="relative" ref={adminMenuRef}>
							<button
								onClick={() => setAdminMenuOpen(prev => !prev)}
								className="flex items-center gap-1 px-4 py-2 rounded-md transition-colors duration-200 text-sm font-medium text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700"
							>
								Admin
								<svg className={`w-4 h-4 transition-transform ${adminMenuOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
								</svg>
							</button>

							{adminMenuOpen && (
								<div className="absolute right-0 mt-2 w-56 max-h-[calc(100vh-6rem)] overflow-y-auto bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg shadow-xl z-50 py-1">
									<AdminMenuSection title="Pagos y Obras" />
									<NavLink
										to="/analisis-pagos"
										onClick={() => setAdminMenuOpen(false)}
										className={adminItemClass}
									>
										Análisis Pagos
									</NavLink>
									<NavLink
										to="/obras-sin-pagos"
										onClick={() => setAdminMenuOpen(false)}
										className={adminItemClass}
									>
										Obras sin pagos
									</NavLink>
									<NavLink
										to="/recuperar-obras"
										onClick={() => setAdminMenuOpen(false)}
										className={adminItemClass}
									>
										Recuperar Obras
									</NavLink>

									<AdminMenuSection title="Ciclo de Obra" />
									<NavLink
										to="/ciclo-de-vida"
										onClick={() => setAdminMenuOpen(false)}
										className={adminItemClass}
									>
										Ciclo de Vida
									</NavLink>
									<NavLink
										to="/ciclo-de-vida-v2"
										onClick={() => setAdminMenuOpen(false)}
										className={adminItemClass}
									>
										Ciclo de Vida V2
									</NavLink>
									<NavLink
										to="/circuito-contactos"
										onClick={() => setAdminMenuOpen(false)}
										className={adminItemClass}
									>
										Circuito contactos
									</NavLink>


									<AdminMenuSection title="Notificaciones y Alertas" />
									<NavLink
										to="/gestion-notificaciones"
										onClick={() => setAdminMenuOpen(false)}
										className={adminItemClass}
									>
										Gestionar Notificaciones
									</NavLink>
									<button
										onClick={() => { setAdminMenuOpen(false); setIsNotifModalOpen(true); }}
										className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800 transition-colors"
									>
										Nueva Notificación
									</button>
									<NavLink
										to="/seguimiento-eventos"
										onClick={() => setAdminMenuOpen(false)}
										className={adminItemClass}
									>
										Seguimiento de Eventos
									</NavLink>
									<NavLink
										to="/alertas-mejoramientos"
										onClick={() => setAdminMenuOpen(false)}
										className={adminItemClass}
									>
										Alertas de Mejoramientos
									</NavLink>
									<NavLink
										to="/alertas-obras"
										onClick={() => setAdminMenuOpen(false)}
										className={adminItemClass}
									>
										Alertas de Obras
									</NavLink>
									<NavLink
										to="/chat-historial"
										onClick={() => setAdminMenuOpen(false)}
										className={adminItemClass}
									>
										Chat Historial
									</NavLink>
									{/* Chat de soporte (admin <-> usuario). Es un botón y no un
									    link porque abre un modal, no una página. El badge
									    es la cola de mensajes que el admin todavía no
									    abrió. */}
									{chatSoporte.disponible && (
										<button
											onClick={() => { setAdminMenuOpen(false); abrirChatSoporte(); }}
											className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800 transition-colors"
										>
											<div className="flex items-center justify-between gap-2">
												<span>Chat de Soporte</span>
												{colaChat > 0 && (
													<span className="inline-flex items-center justify-center min-w-[1.25rem] h-5 px-1 rounded-full bg-red-500 text-white text-xs font-semibold">
														{colaChat}
													</span>
												)}
											</div>
										</button>
									)}

									<AdminMenuSection title="Informes y Monitoreo" />
									<NavLink
										to="/informe-gestion"
										onClick={() => setAdminMenuOpen(false)}
										className={adminItemClass}
									>
										Informe por Partido
									</NavLink>
									<NavLink
										to="/informe-organizaciones"
										onClick={() => setAdminMenuOpen(false)}
										className={adminItemClass}
									>
										Informe de Organizaciones
									</NavLink>
									<NavLink
										to="/informe-clubes-deportivos"
										onClick={() => setAdminMenuOpen(false)}
										className={adminItemClass}
									>
										Informe ONGs/Clubes Deportivos
									</NavLink>
									<NavLink
										to="/monitoreo"
										onClick={() => setAdminMenuOpen(false)}
										className={adminItemClass}
									>
										Monitoreo Stack
									</NavLink>
									<NavLink
										to="/tableros-respaldo"
										onClick={() => setAdminMenuOpen(false)}
										className={adminItemClass}
									>
										Tableros (respaldo)
									</NavLink>
									<NavLink
										to="/base-matriz"
										onClick={() => setAdminMenuOpen(false)}
										className={adminItemClass}
									>
										Base Matriz
									</NavLink>

									<AdminMenuSection title="Administración" />
									<NavLink
										to="/gestion-usuarios"
										onClick={() => setAdminMenuOpen(false)}
										className={adminItemClass}
									>
										Gestión de Usuarios
									</NavLink>
									<NavLink
										to="/api-keys"
										onClick={() => setAdminMenuOpen(false)}
										className={adminItemClass}
									>
										API Keys
									</NavLink>
									<NavLink
										to="/versiones"
										onClick={() => setAdminMenuOpen(false)}
										className={adminItemClass}
									>
										Versiones
									</NavLink>
								</div>
							)}
						</div>
					)}
				</div>
			</nav>
			<div className='flex  flex-grow justify-end items-center gap-3'>
				{/* Sección de usuario */}
				{user ? (
					<>
						<div className="relative flex flex-col items-end">
							<span className="text-sm text-gray-700 dark:text-gray-300">
								Bienvenido, {auth?.user && user}
							</span>
							{/* Indicador de notificaciones sin leer (solo no-admin) */}
							{role !== 'admin' && <NotificacionesUsuarioIndicador />}
						</div>
						<button
							onClick={logout}
							className="px-4 py-2 text-sm font-medium text-red-600 hover:bg-red-50 dark:text-red-400 dark:hover:bg-gray-700 rounded-md transition-colors duration-200"
						>
							Cerrar sesión
						</button>
					</>
				) : (
					<NavLink to="/login" className={linkClasses}>
						Login
					</NavLink>
				)}
			</div>

			{/* Usar el componente Modal reutilizable */}
			<Modal isOpen={isModalOpen} onClose={closeModal} maxWidth="max-w-4xl">
				<div className="w-full">
					<div className="space-y-4 p-4 rounded-lg bg-white dark:bg-gray-900">
						<h3 className="text-lg font-semibold mb-3 dark:text-gray-200">Nueva ONG</h3>
						<FormularioNuevaONG />
					</div>
					{/*<div className="space-y-4 p-4 rounded-lg bg-white dark:bg-gray-900">
                    <h3 className="text-lg font-semibold mb-3 dark:text-gray-200">Nuevo Referente</h3>
                    <FormularioNuevoReferente onSuccess={closeModal} />
                </div>*/}
				</div>
			</Modal>

			{/* Modal para crear notificaciones (solo admin) */}
			<Modal isOpen={isNotifModalOpen} onClose={() => setIsNotifModalOpen(false)} maxWidth="max-w-2xl">
				<div className="w-full">
					<FormularioCrearNotificacion
						onSuccess={() => setIsNotifModalOpen(false)}
						onCancel={() => setIsNotifModalOpen(false)}
					/>
				</div>
			</Modal>

		</>

	);
};

export default Navbar;
